import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgSideToRightSideFill = (props) => /* @__PURE__ */ _jsxs("svg", {
	id: "Right side",
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M7.80198 15.114C7.52098 14.81 7.53798 14.335 7.84198 14.053L10.054 12L7.84198 9.946C7.53798 9.665 7.52098 9.189 7.80198 8.885C8.08398 8.583 8.55798 8.565 8.86198 8.846L11.666 11.45C11.819 11.592 11.906 11.791 11.906 12C11.906 12.209 11.819 12.408 11.666 12.55L8.86198 15.153C8.55798 15.434 8.08398 15.417 7.80198 15.114ZM14.709 2.8C14.709 2.63431 14.5747 2.5 14.409 2.5L7.78398 2.5C4.62398 2.5 2.49998 4.72 2.49998 8.026L2.49998 15.973C2.49998 19.279 4.62298 21.5 7.78298 21.5L14.409 21.5C14.5747 21.5 14.709 21.3657 14.709 21.2L14.709 2.8Z",
		fill: "currentColor"
	}), /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M16.218 21.1998C16.218 21.3654 16.3525 21.5005 16.518 21.493C19.5107 21.3565 21.5 19.173 21.5 15.9738L21.5 8.02576C21.5 4.82649 19.5107 2.64298 16.518 2.50654C16.3525 2.49899 16.218 2.63407 16.218 2.79976L16.218 21.1998Z",
		fill: "currentColor"
	})]
});
export default SvgSideToRightSideFill;
